import { render, staticRenderFns } from "./ListadoGestiones.vue?vue&type=template&id=50d1792a&"
import script from "./ListadoGestiones.vue?vue&type=script&lang=js&"
export * from "./ListadoGestiones.vue?vue&type=script&lang=js&"
import style0 from "./ListadoGestiones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports